var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[(_vm.type == 1)?_c('gain',{attrs:{"details":_vm.details}}):_c('index',{on:{"change":_vm.successChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }